<template>
  <div class="all_part" @click="bar_notShow">
    <div class="head">
      <div class="back" v-show="this.$store.state.pan_CloseNotShow==0"> </div>
      <div class="back" @click="back" v-show="this.$store.state.pan_CloseNotShow==1">
        <img src="../assets/main_menu_Phone/back.png" alt="" width="25px"/>
      </div>
      <div class="titleAndicon">
        <div class="titleName">
          <span>竞品信息登记</span>
        </div>
        <div class="title_icon"  @click="navbarShow" @click.stop>
          <img src="../assets/ProductTablePhone_img/icon.png" alt="" width="30px" />
        </div>
      </div>
    </div>
    <div class="heads" v-if="PanDuanShou">
      <div class="heads_menus" v-if="user_leave.standardType == 1">
        <div class="heads_menu_icon">
          <img
            src="../assets/Main_menu_img/Litle_menu_icon/JiaGeKuCun.png"
            alt=""
          />
        </div>
        <div class="heads_button" @click="Second_jiage">
          <span>价格与库存</span>
        </div>
      </div>
      <dir class="heads_menu" v-if="user_leave.master_gear == 1">
        <div class="heads_menu_icon">
          <img
            src="../assets/Main_menu_img/Litle_menu_icon/ICChanPinXinXi.png"
            alt=""
          />
        </div>
        <div class="heads_button" @click="Second_ZhuDang">
          <span>IC市场信息</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.competitive_products == 1">
        <div class="heads_menu_icon">
          <img
            src="../assets/Main_menu_img/Litle_menu_icon/NeiBuXieTiao.png"
            alt=""
          />
        </div>
        <div class="heads_button" @click="TableInputPhone">
          <span>IC市场情报</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.task == 1">
        <div class="heads_menu_icon">
          <img
            src="../assets/Main_menu_img/Litle_menu_icon/JiaGeKuCun.png"
            alt=""
          />
        </div>
        <div class="heads_button" @click="NeiBuXieTiao">
          <span>内部协调</span>
        </div>
      </dir>
      <dir class="heads_menu" v-if="user_leave.financeType == 1">
        <div class="heads_menu_icon">
          <img
            src="../assets/Main_menu_img/Litle_menu_icon/YingShouKuanYuFaPiao.png"
            alt=""
          />
        </div>
        <div class="heads_button" @click="FinancePhone">
          <span>应收款与发票</span>
        </div>
      </dir>
       <dir class="heads_menu" v-if="user_leave.orderType == 1">
        <div class="heads_menu_icon">
          <img
              src="../assets/Main_menu_img/Litle_menu_icon/YingShouKuanYuFaPiao.png"
              alt=""
          />
        </div>
        <div class="heads_button" @click="DingDanZhongXin">
          <span>订单中心</span>
        </div>
      </dir>
    </div>
    <div class="all_input_all">
      <div class="ss"></div>
      <div class="Ctrl_padding">
        <div class="input_left">
          <div>
            <el-input
              v-model="Opponent_name"
              placeholder="竞争对手公司名称"
              style="width: 135pt"
            ></el-input>
          </div>
          <div>
            <el-select
              v-model="XinXiLaiYuan_Choice"
              placeholder="信息来源"
              style="width: 135pt"
            >
              <el-option
                v-for="item in XinXiLaiYuan_Select"
                :key="item.value"
                :label="item.title"
                :value="item.title"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-input
              v-model="customer"
              placeholder="关联客户"
              style="width: 135pt"
            ></el-input>
          </div>
          <div>
            <el-input
              v-model="Competitor_salesman"
              placeholder="竞争对手业务员"
              style="width: 135pt"
            ></el-input>
          </div>
        </div>
        <div class="input_left">
          <div>
            <el-select
              v-model="JinPin_Choice"
              placeholder="竞品产品类别"
              style="width: 135pt"
            >
              <el-option
                v-for="item in JinPin_select"
                :key="item.value"
                :label="item.title"
                :value="item.title"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select
              v-model="XinXi_Choice"
              placeholder="信息分类"
              style="width: 135pt"
            >
              <el-option
                v-for="item in XinXi_Select"
                :key="item.value"
                :label="item.title"
                :value="item.title"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select
              v-model="HangYe_Choice"
              placeholder="行业类别"
              style="width: 135pt"
            >
              <el-option
                v-for="item in HangYe_select"
                :key="item.value"
                :label="item.title"
                :value="item.title"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select
              v-model="KeHu_Choice"
              placeholder="客户分类"
              style="width: 135pt"
            >
              <el-option
                v-for="item in KeHu_Select"
                :key="item.value"
                :label="item.title"
                :value="item.title"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="bottom_s">
        <div>
          <el-input
            type="textarea"
            :rows="8"
            placeholder="具体描述"
            v-model="textarea"
            style="margin-bottom: 10px"
          >
          </el-input>
        </div>
        <div class="all_input_bottom">

          <div class="all_second_button">
            <div class="Login_button">
              <el-upload
                  class="upload-demo"
                  action="http://hairong.zhongqinchina.com/api/up_files/upload"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :before-remove="beforeRemove"
                  :before-upload="beforeAvatarUpload"
                  :on-success="urlChange"
                  multiple
                  :limit="1"
                  :on-exceed="handleExceed"
                  :file-list="fileList">
                <el-button  type="primary" style="
                height: 34pt;
                width: 97pt;margin-bottom:10px">点击上传</el-button>
              </el-upload>
            </div>
          <div class="sousuoButton">
            <el-button
              type="primary"
              style="
                height: 34pt;
                width: 97pt;
                background-image: linear-gradient(to right, #358fe5, #1d6eb9);
              "
              @click="serchChanPinXiaoLei"
              >点击提交
            </el-button>
          </div>
          <div class="ChongZhi">
            <div class="second_button" @click="clearInput">
              <el-button
                plain
                type="primary"
                style="width: 92px; height: 34pt; font-size: 16px"
                >重置
              </el-button>
            </div>
            <div class="icon_chong">
              <img src="../assets/ChongZhi.png" alt="" width="14px" />
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpUrl } from "../components/publics";

export default {
  name: "TableInputPhone",
  data() {
    return {
      user_leave: {},
      PanDuanShous: true,
      PanDuanShou: false,
      textarea: "",
      Competitor_salesman: "", //竞争对手业务员
      customer: "", //关联客户
      Opponent_name: "", //对手名称
      XinXi_Select: [],
      XinXi_Choice: "",
      JinPin_select: [],
      JinPin_Choice: "",
      HangYe_select: [],
      HangYe_Choice: "",
      KeHu_Select: [],
      KeHu_Choice: "",
      XinXiLaiYuan_Select: [],
      XinXiLaiYuan_Choice: [],
      urlImage: "",
      fileList: [],
    };
  },
  mounted() {
    this.xinXiFenLei();
    this.jingPinChanPin();
    this.hangYe();
    this.KeHu();
    this.XinXiLaiYuan();
    this.getUser();
  },
  methods: {
    bar_notShow() {
      this.PanDuanShou = false;
    },
    Second_jiage() {
      this.$router.push("/Main_menuPhone_JiaGeYuKuCun");
    },
    Second_ZhuDang() {
      this.$router.push("/ICChanPinXinXi_phone");
    },
    TableInputPhone() {
      this.$router.push("/TableInputPhone");
    },
    NeiBuXieTiao() {
      this.$router.push("/missionPhone");
    },

    FinancePhone() {
      this.$router.push("/FinancePhone");
    },
    DingDanZhongXin() {
      this.$router.push("/OrderPlone");
    },
    navbarShow() {
      if (this.PanDuanShou) {
        this.PanDuanShou = !this.PanDuanShou;
      } else {
        this.PanDuanShou = !this.PanDuanShou;
      }
    },
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave);
    },
    clearInput() {},
    back() {
      this.$router.push("/Main_menuPhone");
    },
    urlChange(e) {
      console.log("url", e);
      if (e.code == 200) {
        this.urlImage = e.data.img;
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {},
    beforeAvatarUpload(file) {
      console.log("file", file);
      // accept=".jpg,.jpeg,.png,.pdf,.JPG,.JPEG,.PDF,DOC"

      let fileName = file.name.substring(file.name.lastIndexOf(".") + 1);
      var arr = [
        "png",
        "jpeg",
        "jpg",
        "pdf",
        "doc",
        "PNG",
        "JPEG",
        "JPG",
        "PDF",
        "DOC",
      ];
      let status = arr.findIndex((value, key) => {
        return fileName == value;
      });
      console.log("fileName", fileName, status);
      if (status == -1) {
        this.$message("上传文件只能是 png、jpeg、jpg、pdf、doc格式!");
        return false;
      }
      // if(!extension && !extension2) {
      //   this.$message({
      //     message: '上传文件只能是 xls、xlsx格式!',
      //     type: 'warning'
      //   });
      // }
    },
    xinXiFenLei() {
      this.axios
        .get(httpUrl + `/api/index/classification`)
        .then((response) => {
          if (response.data.code == 200) {
            this.XinXi_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    jingPinChanPin() {
      this.axios
        .get(httpUrl + `/api/index/categoryList`)
        .then((response) => {
          if (response.data.code == 200) {
            this.JinPin_select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    hangYe() {
      this.axios
        .get(httpUrl + `/api/index/industry`)
        .then((response) => {
          if (response.data.code == 200) {
            this.HangYe_select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    KeHu() {
      this.axios
        .get(httpUrl + `/api/index/customer_category  `)
        .then((response) => {
          if (response.data.code == 200) {
            this.KeHu_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    XinXiLaiYuan() {
      this.axios
        .get(httpUrl + `/api/index/source`)
        .then((response) => {
          if (response.data.code == 200) {
            this.XinXiLaiYuan_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPinXiaoLei() {
      if (
        this.Opponent_name == "" &&
        this.XinXiLaiYuan_Choice == "" &&
        this.customer == "" &&
        this.JinPin_Choice == "" &&
        this.HangYe_Choice == "" &&
        this.KeHu_Choice == "" &&
        this.XinXi_Choice == "" &&
        this.textarea == "" &&
        this.Competitor_salesman == ""
      ) {
        this.$message("请填写信息");
        return;
      }
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      console.log(this.fileList);
      this.axios
        .post(
          httpUrl + `/api/index/competitive_products`,
          this.$qs.stringify({
            competitive_name: this.Opponent_name,
            source: this.XinXiLaiYuan_Choice,
            customer: this.customer,
            category: this.JinPin_Choice,
            industry: this.HangYe_Choice,
            customer_category: this.KeHu_Choice,
            classification: this.XinXi_Choice,
            description: this.textarea,
            customer_contact: this.Competitor_salesman,
            url: this.urlImage,
            user_id: selectID,
          })
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.$message(response.data.message);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    // UpdateImg() {
    //   console.log(this.fileList)
    //   this.axios
    //       .post(httpUrl + `index.php/api/up_files/upload`,this.$qs.stringify({
    //           file:this.file
    //       }))
    //       .then((response) => {
    //         if (response.data.code == 200) {
    //           this.$message(response.data.message)
    //         }
    //         // this.$message("搜索成功");
    //         console.log("success", response.data);
    //       })
    //       .catch((error) => console.log(error, "error"));
    // },
  },
};
</script>

<style>
</style>
<style scoped>
.heads_menus {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}
.heads_menu {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}
.heads_menu_icon img {
  width: 24px;
}
.heads {
  padding-top: 40px;
  flex-direction: column;
  width: 42%;
  justify-content: space-around;
  display: flex;
  align-items: center;
  height: 300px;
  background-color: #ffffff;
  position: fixed;
  right: 0;
  z-index: 98;
  border-radius: 4px;
  box-shadow: 2px 1px 6px 6px #ccc;
}
.heads span {
  color: #000;
  font-size: 13px;
  line-height: 20px;
  font-weight: 250;
}
.heads_button {
  width: 70%;
  height: 40px;
  display: flex;

  align-items: center;
  justify-content: center;
}
.heads_menu {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}
.heads_menu_icon img {
  width: 24px;
}
.input_left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.list_div_div {
  width: 30%;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
.all_part {
  min-height: 100vh;
  background-color: #f2f2f2;
}

.head {
  width: 100%;
  /* justify-content: space-between; */
  display: flex;
  align-items: center;
  height: 45px;
  background-image: url("../assets/main_menu_Phone/bg@3x.png");
  position: fixed;
  z-index: 99;
}

.head span {
  color: #ffffff;
  font-size: 20px;
  line-height: 20px;
  font-weight: 550;
}
.back img {
  margin-top: 5px;
}
.titleName {
  display: flex;
  justify-content: center;
}

.back {
  margin: 0 5px;
}

.all_input {
  display: flex;
  flex-direction: column;
  padding: 0 5px;
  background-color: #ffffff;
  height: 32%;
}

.all_input_top {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.Ctrl_padding {
  height: 40%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_top_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.all_input_all {
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 10px;
}

.all_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 15px;
  margin-top: 15px;
}

.input {
  margin-bottom: 10px;
}
.all_key {
  display: flex;
  flex-direction: row;
}
.two_spans {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: aqua;
}
.Key {
  width: 48%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 8pt;
  margin-bottom: 4px;
  justify-content: space-between;
}

.serch {
  width: 60%;
}

.list_div {
  margin-top: 20px;
  background: #ffffff;
  background-image: url("../assets/table_logo2.png");
  border-radius: 5px;
  padding: 10px 7px;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}

.submit_button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 20px;
}

.all_second_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
}
.titleAndicon {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.title_icon {
  margin-right: 20px;
}
.sousuoButton {
  position: relative;
}
.sousuo_icon {
  top: 16px;
  left: 16px;
  position: absolute;
}
.ChongZhi {
  position: relative;
}
.icon_chong {
  top: 16px;
  left: 10px;
  position: absolute;
}
.ShouQi {
  margin-bottom: 10px;
}
.icon_Shou {
  top: 14px;
  left: 12px;
  position: absolute;
}
.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
  transform: rotate(180deg);
}
.all_spans1 {
  width: 50%;
  display: flex;
  flex-direction: column;
}
.all_spans {
  padding: 0 10px;
}
.titles {
  width: 100%;
  margin-top: 10px;
  display: flex;
}
.ss {
  height: 100px;
}
.XinJiuBianHao {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.second_span {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}
.double_span {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.double_spans {
  width: 48%;
}
.list_div_divs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.list_div_div {
  width: 30%;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
.list_div {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  padding: 6px 14px;
  /* background-image: url(./../assets/img_cx_sylogo@2x.png); */
  background-size: 190px 102px;
}

.list_div_p_span {
  color: #008de3;
}

.list_div_span {
  color: #222222;
}

.list_div_p {
  font-size: 12px;
  line-height: 12px;
  color: #a2a2a2;
  text-align: left;
  margin: 6.5px 0;
}
.all_input_bottom {
  flex-direction: column;
  height: 20%;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-around;
}
.input_left div {
  margin-bottom: 20px;
}
</style>